function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "151.78",
  height: "41.999"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1663",
  "data-name": "Rectangle 1663",
  fill: "none",
  d: "M0 0h151.78v41.999H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4523",
  "data-name": "Group 4523",
  transform: "translate(10604.84 19303.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4008",
  "data-name": "Group 4008",
  transform: "translate(-10604.84 -19303.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4070",
  "data-name": "Group 4070"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1581",
  "data-name": "Path 1581",
  d: "M64.062 35.924l-.664-.958a3.266 3.266 0 00.664.958",
  transform: "translate(-41.788 -22.738)",
  fill: "#f36910"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4071",
  "data-name": "Group 4071"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4225",
  "data-name": "Group 4225"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4226",
  "data-name": "Group 4226"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4226-2",
  "data-name": "Group 4226"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4225-2",
  "data-name": "Group 4225",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1630",
  "data-name": "Path 1630",
  d: "M137.542 39.183l-.887-3.376H130.8l-.912 3.376h-5.345l5.88-18.083h6.489l5.951 18.086zm-1.9-7.367l-.776-2.957q-.271-.985-.659-2.55t-.512-2.242q-.11.628-.438 2.07t-1.447 5.679z",
  transform: "translate(-77.733 -13.167)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1631",
  "data-name": "Path 1631",
  d: "M186.515 45.624V38.01a4.369 4.369 0 00-.4-2.1 1.368 1.368 0 00-1.287-.709 1.863 1.863 0 00-1.762.973 7.357 7.357 0 00-.542 3.338v6.111h-4.818V31.665h3.635l.6 1.725h.283a3.816 3.816 0 011.706-1.478 6.036 6.036 0 012.507-.493 4.757 4.757 0 013.6 1.343 5.244 5.244 0 011.288 3.782v9.08z",
  transform: "translate(-110.912 -19.609)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1632",
  "data-name": "Path 1632",
  d: "M231.486 45.624V38.01a4.369 4.369 0 00-.4-2.1 1.368 1.368 0 00-1.286-.71 1.863 1.863 0 00-1.762.973 7.358 7.358 0 00-.542 3.338v6.111h-4.818V31.665h3.635l.6 1.725h.283a3.816 3.816 0 011.706-1.478 6.037 6.037 0 012.507-.493 4.758 4.758 0 013.6 1.343 5.241 5.241 0 011.288 3.782v9.08z",
  transform: "translate(-138.979 -19.609)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1633",
  "data-name": "Path 1633",
  d: "M279.977 38.611a7.388 7.388 0 01-1.842 5.341 6.822 6.822 0 01-5.156 1.917 6.682 6.682 0 01-5.058-1.959 7.335 7.335 0 01-1.879-5.3 7.284 7.284 0 011.842-5.3 6.88 6.88 0 015.168-1.891 7.37 7.37 0 013.634.875 5.976 5.976 0 012.433 2.507 8.094 8.094 0 01.857 3.813m-9.044 0a6.2 6.2 0 00.481 2.741 1.669 1.669 0 001.614.943 1.622 1.622 0 001.583-.943 6.415 6.415 0 00.462-2.741 6.094 6.094 0 00-.468-2.7 1.855 1.855 0 00-3.191-.006 5.958 5.958 0 00-.481 2.7",
  transform: "translate(-166.045 -19.606)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1634",
  "data-name": "Path 1634",
  d: "M315.584 37.832a7.164 7.164 0 002.329-.48v3.512a9.468 9.468 0 01-1.854.6 10.5 10.5 0 01-2.059.176 4.508 4.508 0 01-3.5-1.189 5.328 5.328 0 01-1.072-3.653v-5.755h-1.688v-1.959l2.142-1.516 1.245-2.932h3.154v2.8h3.419v3.608h-3.425v5.433q0 1.355 1.306 1.355",
  transform: "translate(-192.067 -15.377)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1635",
  "data-name": "Path 1635",
  d: "M349.874 39.183l-.887-3.376h-5.852l-.912 3.376h-5.347l5.877-18.083h6.494l5.953 18.083zm-1.9-7.367l-.776-2.957q-.271-.985-.659-2.55t-.512-2.242q-.111.628-.438 2.07t-1.447 5.679z",
  transform: "translate(-210.254 -13.167)",
  fill: "#009cdc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1662",
  "data-name": "Rectangle 1662",
  transform: "translate(146.889 8.003)",
  fill: "#009cdc",
  d: "M0 0h4.891v18.012H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1636",
  "data-name": "Path 1636",
  d: "M325.752 78.547v1.513q0 .26-.014.506t-.021.382h.035a1.444 1.444 0 01.506-.486 1.621 1.621 0 01.844-.2 1.6 1.6 0 011.278.554 2.469 2.469 0 01.477 1.648 3.007 3.007 0 01-.218 1.214 1.64 1.64 0 01-.615.747 1.707 1.707 0 01-.937.253 1.639 1.639 0 01-.831-.188 1.437 1.437 0 01-.5-.461h-.05l-.132.572h-.467v-6.054zM327 80.8a1.315 1.315 0 00-.736.181 1 1 0 00-.391.545 3.009 3.009 0 00-.118.92v.038a2.325 2.325 0 00.268 1.231 1.062 1.062 0 00.977.426 1.01 1.01 0 00.893-.436 2.2 2.2 0 00.3-1.245 2.153 2.153 0 00-.294-1.24 1.023 1.023 0 00-.9-.416",
  transform: "translate(-202.908 -49.023)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1637",
  "data-name": "Path 1637",
  d: "M336.286 83.308h.694l.942 2.474q.082.218.15.418c.047.133.088.263.124.383a3.267 3.267 0 01.086.354h.027q.055-.195.156-.512t.218-.648l.891-2.471h.7l-1.856 4.89a3.314 3.314 0 01-.345.685 1.4 1.4 0 01-.477.451 1.358 1.358 0 01-.677.157 2.112 2.112 0 01-.323-.021 2.3 2.3 0 01-.241-.048v-.52a2.108 2.108 0 00.208.035 2.061 2.061 0 00.255.016.9.9 0 00.418-.091.877.877 0 00.306-.266 1.806 1.806 0 00.222-.416l.233-.6z",
  transform: "translate(-209.886 -51.995)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1638",
  "data-name": "Path 1638",
  d: "M354.028 85.209v-5.688h1.537v4.447h2.191v1.24z",
  transform: "translate(-220.959 -49.631)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1639",
  "data-name": "Path 1639",
  d: "M368.181 85.209h-1.537v-4.432h-1.391v-1.256h4.311v1.257h-1.384z",
  transform: "translate(-227.966 -49.631)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1640",
  "data-name": "Path 1640",
  d: "M380.705 85.209h-1.537v-4.432h-1.391v-1.256h4.311v1.257H380.7z",
  transform: "translate(-235.782 -49.631)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1641",
  "data-name": "Path 1641",
  d: "M394.7 83.342a1.678 1.678 0 01-.268.94 1.757 1.757 0 01-.775.639 2.863 2.863 0 01-1.186.228 4.766 4.766 0 01-.953-.08 3.543 3.543 0 01-.8-.278v-1.37a4.6 4.6 0 00.914.352 3.4 3.4 0 00.872.126.846.846 0 00.5-.119.363.363 0 00.16-.305.34.34 0 00-.064-.2.744.744 0 00-.206-.177q-.142-.09-.757-.366a3.615 3.615 0 01-.834-.489 1.5 1.5 0 01-.414-.545 1.806 1.806 0 01-.135-.727 1.457 1.457 0 01.572-1.225 2.52 2.52 0 011.572-.44 4.414 4.414 0 011.8.409l-.471 1.187a3.41 3.41 0 00-1.378-.366.717.717 0 00-.436.105.318.318 0 00-.136.26.376.376 0 00.173.3 6.52 6.52 0 00.94.483 2.6 2.6 0 011.021.71 1.539 1.539 0 01.286.955",
  transform: "translate(-243.855 -49.492)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1642",
  "data-name": "Path 1642",
  d: "M38.157 43.726a1.909 1.909 0 11-1.909-1.909 1.909 1.909 0 011.909 1.909",
  transform: "translate(-21.431 -26.099)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1643",
  "data-name": "Path 1643",
  d: "M3.819 96.559a1.909 1.909 0 11-1.91-1.909 1.909 1.909 0 011.909 1.909",
  transform: "translate(0 -59.074)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1644",
  "data-name": "Path 1644",
  d: "M52.43 22.119a1.909 1.909 0 11-1.91-1.909 1.909 1.909 0 011.909 1.909",
  transform: "translate(-30.34 -12.614)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1645",
  "data-name": "Path 1645",
  d: "M16.666 51.782L6.831 66.841A3.037 3.037 0 018.609 68l9.848-15.08a3.038 3.038 0 01-1.792-1.137",
  transform: "translate(-4.263 -32.319)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1646",
  "data-name": "Path 1646",
  d: "M16.618 50.483l.644.845a2.288 2.288 0 001.349.857l1.075.225L8.649 69.309l-.642-.863a2.288 2.288 0 00-1.339-.872l-1.058-.235zm.7 2.813a3.789 3.789 0 01-.524-.335L7.967 66.473a3.79 3.79 0 01.521.34z",
  transform: "translate(-4.263 -32.319)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1647",
  "data-name": "Path 1647",
  d: "M32.987 14.442a4.4 4.4 0 001.771-1.17L55.67 43.413a2.425 2.425 0 003.809.223 2.729 2.729 0 00.231-3.41L43.77 16.088a3.041 3.041 0 00-2.218-2.488l1.572-2.343 18.357 27.8a4.967 4.967 0 01-4.074 7.687 2.224 2.224 0 01-.316-.027 4.591 4.591 0 01-3.067-1.955z",
  transform: "translate(-20.588 -7.027)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1648",
  "data-name": "Path 1648",
  d: "M43.129 9.905l18.977 28.74a5.717 5.717 0 01-4.7 8.85 2.927 2.927 0 01-.425-.035 5.353 5.353 0 01-3.574-2.269l-21.6-31.128.926-.327a3.667 3.667 0 001.469-.971l.634-.689 21.446 30.91a1.675 1.675 0 002.631.154 1.993 1.993 0 00.167-2.5L43.052 16.362l-.024-.165a2.282 2.282 0 00-1.67-1.871l-1.014-.271zm14.277 36.09a4.217 4.217 0 003.449-6.523L43.119 12.613l-.439.654a3.781 3.781 0 011.8 2.539l15.856 24.008a3.491 3.491 0 01.586 2.423 3.679 3.679 0 01-.878 1.894 3.175 3.175 0 01-4.99-.29L34.627 14.4a5.194 5.194 0 01-.517.345l20.53 29.59a3.848 3.848 0 002.561 1.64 1.471 1.471 0 00.205.02z",
  transform: "translate(-20.588 -7.027)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1649",
  "data-name": "Path 1649",
  d: "M26.943 3.271A3.271 3.271 0 1123.672 0a3.271 3.271 0 013.271 3.271",
  transform: "translate(-12.733)",
  fill: "#009cdc"
})))))))))));